var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4584 13.6667H8.54175C5.70591 13.6667 3.41675 15.9558 3.41675 18.7917V29.0417H10.2501V35.875H30.7501V29.0417H37.5834V18.7917C37.5834 15.9558 35.2942 13.6667 32.4584 13.6667ZM27.3334 32.4583H13.6667V23.9167H27.3334V32.4583ZM32.4584 20.5C31.5188 20.5 30.7501 19.7313 30.7501 18.7917C30.7501 17.8521 31.5188 17.0833 32.4584 17.0833C33.398 17.0833 34.1667 17.8521 34.1667 18.7917C34.1667 19.7313 33.398 20.5 32.4584 20.5ZM30.7501 5.125H10.2501V11.9583H30.7501V5.125Z",
    fill: "#ABBBC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printer_icon.40c6cc7b583105c3a5317739ca0922b6.svg";
export { ForwardRef as ReactComponent };